import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { CDMOProfile } from "../components/CDMOProfile";

const CDMOApplication: React.FC = () => {
  const [searchParams] = useSearchParams();
  const editId = searchParams.get('edit');

  return (
    <CDMOProfile mode={editId ? "edit" : "create"} cdmoId={editId || undefined} />
  );
}

export default CDMOApplication